import { LifestyleMainPageTemplate } from "./template";
import { useLifestyleMainPage } from "./logic";

export const LifestyleMainPage = () : JSX.Element => {
    const props = useLifestyleMainPage();

    return (
        <LifestyleMainPageTemplate {...props}/>
    )
} 